export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        ele.addEventListener('keydown', event => {
            if (
                event.target.matches("[type='radio']") &&
                event.which === 13 /* Enter */
            ) {
                event.target.click();
                event.preventDefault();
                event.stopPropagation();
            }
        });

        ele.addEventListener('change', trackFilterSelection);

        function trackFilterSelection(event) {
            const radio = event.target;
            if (radio.checked) {
                trackingservice.trackEventObject({
                    analyticsName: `navigation.filter-by-${radio.name.replace(
                        /_/g,
                        ''
                    )}.click`,
                    stringValue: `${radio.name}:${radio.value}`,
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/singleSelectWidget.js